import { agentsApi, type AgentRunPageView } from '../../../../agents/data';

/** Fixed agent key for the EVA agent (no shared exported constant exists elsewhere yet). */
export const EVA_AGENT_KEY = 'eva';

/**
 * Agent-activity endpoints injected into the single Agents backend api (`agentsApi`) — this feature
 * lives in `financialClearance` but reads across into the Agents backend (spec 042 US2), mirroring the
 * cross-backend pattern already used by `modules/agents` (`agentsVerificationsApi`). Only
 * `getRunsBySubject` is new; run detail reuses the existing `runs` feature endpoint (re-exported below)
 * rather than duplicating it.
 */
export const agentActivityEndpoints = agentsApi.injectEndpoints({
  endpoints: (builder) => ({
    getRunsBySubject: builder.query<AgentRunPageView, { subjectId: string }>({
      query: ({ subjectId }) => ({
        url: `/agents/${EVA_AGENT_KEY}/runs`,
        method: 'GET',
        params: { subjectId, pageSize: 1 },
      }),
      providesTags: (_result, _error, { subjectId }) => [{ type: 'AgentRuns', id: subjectId }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetRunsBySubjectQuery } = agentActivityEndpoints;

/** Reused as-is — no second `getRunDetail` endpoint for the same backend route. */
export { useGetRunDetailQuery } from '../../../../agents/data';
